export enum KnmErknmActionsEnum {
  KNM_ERKNM_INIT_SELECT_OPTIONS = 'KNM_ERKNM_INIT_SELECT_OPTIONS',
  KNM_SET_INITIAL_FORM_VALUES = 'KNM_SET_INITIAL_FORM_VALUES',
  KNM_ERKNM_RESET_INITIAL_FORM_VALUES = 'KNM_ERKNM_RESET_INITIAL_FORM_VALUES',
  KNM_ERKNM_SET_FIELDS_FOR_APPROVING = 'KNM_ERKNM_SET_FIELDS_FOR_APPROVING',
  KNM_ERKNM_SET_IS_SHOW_MESSAGE_BY_STATUS = 'KNM_ERKNM_SET_IS_SHOW_MESSAGE_BY_STATUS',
  KNM_ERKNM_SET_WAS_FIRST_INIT = 'KNM_ERKNM_SET_WAS_FIRST_INIT',
  KNM_ERKNM_SET_PRESCRIPTION_OLD_RULES = 'KNM_ERKNM_SET_PRESCRIPTION_OLD_RULES',
  KNM_ERKNM_SET_PRESCRIPTION_FAILED = 'KNM_ERKNM_SET_PRESCRIPTION_FAILED',
}
